import ResizeObserver from 'resize-observer-polyfill';
// import { debounce } from 'lodash';
import { debounce } from '@/libs/utils.js';
import Vue from 'vue';
const resize = Vue.directive('resize', {
  inserted: function (el, binding) {
    const observer = new ResizeObserver(
      debounce((entries) => {
        binding.value(entries[0].contentRect);
      }, 100)
    );
    observer.observe(el);
  },
});
export default resize;
